import { useCallback, useState } from 'react';
import { STORAGE_KEY_COLLAPSED, STORAGE_KEY_DISMISSED } from './constants';

const readBoolean = key => sessionStorage.getItem(key) === 'true';
const writeBoolean = (key, value) => sessionStorage.setItem(key, value ? 'true' : 'false');

export function useCollapseState(placement) {
  const collapsedKey = `${STORAGE_KEY_COLLAPSED}__${placement}`;
  const dismissedKey = `${STORAGE_KEY_DISMISSED}__${placement}`;

  const [isCollapsed, setIsCollapsed] = useState(() => readBoolean(collapsedKey));
  const [isDismissed, setIsDismissed] = useState(() => readBoolean(dismissedKey));

  const toggleCollapse = useCallback(() => {
    setIsCollapsed(prev => {
      const next = !prev;
      writeBoolean(collapsedKey, next);
      return next;
    });
  }, [collapsedKey]);

  const dismiss = useCallback(() => {
    setIsDismissed(true);
    writeBoolean(dismissedKey, true);
  }, [dismissedKey]);

  return { isCollapsed, isDismissed, toggleCollapse, dismiss };
}